module.exports = __webpack_public_path__ + "img/fail.44a5160a.png";